import React, { useRef, useState } from "react";

interface Props {
  url: string;
}

const SendNotification = ({ url }: Props) => {
  const [mail, setMail] = useState<string>("");
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (): void => {
    setMail(inputRef?.current?.value || "");
  };

  const handleClickUserArrival = (): void => {
    if (mail) {
      fetch(`${url}/sendArrival/${mail}`);
    } else {
      alert("Aucun mail renseigné");
    }
  };

  const handleClickUserDeparture = (): void => {
    if (mail) {
      fetch(`${url}/sendDeparture/${mail}`);
    } else {
      alert("Aucun mail renseigné");
    }
  };

  return (
    <div className="permissions">
      <h1>Envoi d'une notification</h1>

      <div className="permissions-container">
        <div>Il est maintenant possible de requêter le tenant client à n'importe quel moment</div>
        <div>Le bouton ci-dessous enverra une notification d'arrivée à la personne à laquelle correspond l'email renseigné ci-dessous</div>
        <input ref={inputRef} className="home-text" type="text" value={mail} placeholder="email du destinataire" onChange={handleChange}></input>
        <button className="home-button" onClick={handleClickUserArrival}>
          Envoyer une notification d'arrivée
        </button>
        <button className="home-button" onClick={handleClickUserDeparture}>
          Envoyer une notification de départ
        </button>
      </div>
    </div>
  );
};

export default SendNotification;
